import { ColumnContainer } from './container'
import { ColumnContent } from './content'
import { ColumnFooter } from './footer'
import { ColumnHeader } from './header'

export const Column = Object.assign(ColumnContainer, {
    Container: ColumnContainer,
    Content: ColumnContent,
    Footer: ColumnFooter.Input,
    Header: ColumnHeader.Input,
})
